import styled from 'styled-components'

import { Input } from '../Input'

export const InputCep = styled(Input)``
